





















import { NextQuery } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    }),
    ...mapState(SUBMODULES_PATHS.querySignals, ['nextQueriesQuery'])
  }
})
export default class NextQueriesSuggestions extends Vue {
  nextQueriesQuery: string;

  @Prop({ required: true })
  suggestions: NextQuery[];

  @Prop({ required: true })
  highlightedEmpathizeItem: any;

  @Prop({ default: EVENTS.SelectNextQuery })
  event: string;

  get titleMessageParams() {
    return { query: this.nextQueriesQuery };
  }
}
